import axios from "axios";

export const WHATSAPP_URL =
  "https://wa.me/5511988891096?text=" +
  encodeURIComponent("Olá! Vim pelo site e preciso de ajuda com gás encanado.");

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Algo deu errado. Tente novamente.";
}
